'use client';

import { ReactNode } from 'react';
import { AnimatedGradientBackground } from '@/components/AnimatedGradientBackground';
import { MentorSearchBackButton } from '@/components/MentorSearchBackButton';
import Section from '@/components/ui/Section';

interface ProfilePageWrapperProps {
  headerContent: ReactNode;
  children: ReactNode;
}

export function ProfilePageWrapper({ headerContent, children }: ProfilePageWrapperProps) {
  return (
    <>
      {/* Animated gradient header */}
      <AnimatedGradientBackground animateOnEnter>
        <div style={{ position: 'relative' }}>
          <MentorSearchBackButton />
          <Section py="sm">
            {headerContent}
          </Section>
        </div>
      </AnimatedGradientBackground>
      
      {/* Main content */}
      {children}
    </>
  );
}
